export class Gai {
    prompt: string;
    responseWordLimit: number;
    aiResponse: string;
}